import React from 'react'

const EdgeImage = (props) => {

    let {img, extraClass, extraTileBG} = props;

  return (
    <div className='imgBottomMain'>
        <div className={`extraTile ${extraTileBG}`}></div>
        <div>
            <img src={img} className={extraClass} alt='' />
        </div>
    </div>
  )
}

export default EdgeImage